import { cloneDeep } from 'lodash-es';

/***
 *  @returns  deep copy of an input object
 *
 */

export const clone = object => cloneDeep(object);
